<template>
  <step :active="1"></step>
  <div class="quetions">
    <div class="quItem" v-for="item in qus" :key="item.QuestionsID">
      <h3 class="queTit">
        <span style="color: red" v-if="item.Questions_IsRequired">*</span
        >{{ item.QuestionsQusTitle }}
      </h3>
      <div class="queSelItem">
        <!-- 多选 -->
        <van-checkbox-group
          v-if="item.Question_QusType === 'M'"
          v-model="item.checked"
        >
          <div class="opItem">
            <template
              v-for="itemo in item.AnswersCollect"
              :key="itemo.AnswersID"
            >
              <!-- 二级 -->
              <div
                class="hasSec"
                v-if="itemo.ChildAnswers && itemo.ChildAnswers.length > 0"
              >
                <van-checkbox-group
                  v-model="itemo.firstChecked"
                  @change="firstCheckChange(item, itemo)"
                >
                  <van-checkbox
                    :key="itemo.AnswersID"
                    :name="itemo.AnswersID"
                    :checked-color="mainColor"
                    icon-size="18px"
                    shape="square"
                  >
                    {{ itemo.AnswersTitle }}
                  </van-checkbox>
                </van-checkbox-group>
                <!-- 二级显示 -->
                <div v-show="itemo.firstChecked.length > 0">
                  <div
                    v-for="items in itemo.ChildAnswers"
                    :key="items.AnswersID"
                    class="secBox"
                  >
                    <van-checkbox
                      :checked-color="mainColor"
                      icon-size="18px"
                      shape="square"
                      :name="items.AnswersID"
                      :class="items.AnswersIsInput ? 'otherTxt' : ''"
                      @click="changeQueAns(item, items)"
                    >
                      {{ items.AnswersTitle }}
                    </van-checkbox>
                    <!-- 其他 -->
                    <van-field
                      v-if="items.AnswersIsInput"
                      v-model="items.otherCon"
                      @click.stop
                      class="otherConFiled"
                      :disabled="item.checked.indexOf(items.AnswersID) === -1"
                      :placeholder="items.AnswersInputText || '请填写'"
                    />
                  </div>
                </div>
              </div>
              <!-- 二级end -->
              <!-- 一级 -->
              <div v-else>
                <van-checkbox
                  :checked-color="mainColor"
                  icon-size="18px"
                  shape="square"
                  :name="itemo.AnswersID"
                  :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                  @click="changeQueAns(item, itemo)"
                >
                  {{ itemo.AnswersTitle }}
                </van-checkbox>
                <!-- 其他 -->
                <van-field
                  v-if="itemo.AnswersIsInput"
                  v-model="itemo.otherCon"
                  @click.stop
                  class="otherConFiled"
                  :disabled="item.checked.indexOf(itemo.AnswersID) === -1"
                  :placeholder="itemo.AnswersInputText || '请填写'"
                />
              </div>
              <!-- 一级end -->
            </template>
          </div>
        </van-checkbox-group>
        <!-- 单选 -->
        <van-radio-group
          v-if="item.Question_QusType === 'S'"
          v-model="item.checked"
        >
          <template v-for="itemo in item.AnswersCollect" :key="itemo.AnswersID">
            <div
              class="hasSec"
              v-if="itemo.ChildAnswers && itemo.ChildAnswers.length > 0"
            >
              <van-radio
                :checked-color="mainColor"
                icon-size="18px"
                :name="itemo.AnswersID"
                :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                @click="firstCheckChange(item, itemo)"
              >
                {{ itemo.AnswersTitle }}
              </van-radio>
              <!-- 单选二级 -->
              <div
                v-show="item.checked === itemo.AnswersID"
                style="padding-left: 15px"
              >
                <van-radio-group v-model="itemo.firstChecked">
                  <template
                    v-for="items in itemo.ChildAnswers"
                    :key="items.AnswersID"
                  >
                    <van-radio
                      :checked-color="mainColor"
                      icon-size="18px"
                      :name="items.AnswersID"
                      :class="items.AnswersIsInput ? 'otherTxt' : ''"
                      @click="changeQueAns(item, items)"
                    >
                      {{ items.AnswersTitle }}
                    </van-radio>
                    <!-- 其他 -->
                    <van-field
                      v-if="items.AnswersIsInput"
                      v-model="items.otherCon"
                      @click.stop
                      class="otherConFiled"
                      :placeholder="items.AnswersInputText || '请填写'"
                      :disabled="itemo.firstChecked !== items.AnswersID"
                    />
                  </template>
                </van-radio-group>
              </div>
            </div>
            <div v-else>
              <van-radio
                :checked-color="mainColor"
                icon-size="18px"
                :name="itemo.AnswersID"
                :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                @click="changeQueAns(item, itemo)"
              >
                {{ itemo.AnswersTitle }}
              </van-radio>
              <!-- 其他 -->
              <van-field
                v-if="itemo.AnswersIsInput"
                v-model="itemo.otherCon"
                @click.stop
                class="otherConFiled"
                :placeholder="itemo.AnswersInputText || '请填写'"
                :disabled="item.checked !== itemo.AnswersID"
              />
            </div>
          </template>
        </van-radio-group>
        <!-- 填空 -->
        <van-radio-group
          v-if="item.Question_QusType === 'F'"
          v-model="item.checked"
        >
          <template v-for="itemo in item.AnswersCollect" :key="itemo.AnswersID">
            <div>
              <van-radio
                style="display: none"
                :checked-color="mainColor"
                icon-size="18px"
                :name="itemo.AnswersID"
                :class="itemo.AnswersIsInput ? 'otherTxt' : ''"
                @click="changeQueAns(item, itemo)"
              >
                {{ itemo.AnswersTitle }}
              </van-radio>
              <!-- 其他 -->
              <van-field
                v-if="itemo.AnswersIsInput"
                v-model="itemo.otherCon"
                @click.stop
                class="otherConFiled"
                :placeholder="itemo.AnswersInputText || '请填写'"
                :disabled="item.checked !== itemo.AnswersID"
              />
            </div>
          </template>
        </van-radio-group>
      </div>
    </div>
  </div>
  <div class="quebtns">
    <van-button @click="goback" :color="mainColor" type="primary">
      上一步
    </van-button>
    <van-button type="primary" :color="mainColor" @click="nextHandler">
      下一步
    </van-button>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { showFailToast } from 'vant'
import { useStore } from 'vuex'
import api from '@/api'
import wx from '@/utils/wx.js'
import step from '@/components/step.vue'
import { decryptionECB } from '@/utils/utils.js'
const store = useStore()
const router = useRouter()
const ExhCode = computed(() => store.state.ExhCode)
const VisitorID = computed(() => store.state.VisitorID)
const token = computed(() => store.state.token)
const mainColor = computed(() => store.state.mainColor)
const isWeX = computed(() => store.state.isWeX)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const firstCheckChange = (qObj, fObj) => {
  if (qObj.Question_QusType === 'M') {
    if (fObj.firstChecked.length <= 0) {
      fObj.ChildAnswers.forEach((item) => {
        item.otherCon = ''
        const index = qObj.checked.indexOf(item.AnswersID)
        if (index > -1) {
          qObj.checked.splice(index, 1)
        }
      })
    }
  } else {
    // 一级单选切换
    qObj.AnswersCollect.forEach((item) => {
      if (item.ChildAnswers && item.ChildAnswers.length > 0) {
        item.firstChecked = ''
        item.ChildAnswers.forEach((items) => {
          items.otherCon = ''
        })
      }
    })
  }
}
const qus = ref([])
const getAns = async () => {
  const res = await api.getAnswersApi({ ExhCode: ExhCode.value })
  const jmRes = JSON.parse(decryptionECB(res.data))
  // console.log(jmRes, '222')
  jmRes.AnswersQuestions = jmRes.AnswersQuestions.sort((a, b) => {
    return a.Questions_Sort - b.Questions_Sort
  })
  jmRes.AnswersQuestions.forEach((item) => {
    if (item.AnswersCollect && item.AnswersCollect.length > 0) {
      // 二级选项排序
      item.AnswersCollect.forEach((item2) => {
        if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
          item2.ChildAnswers = item2.ChildAnswers.sort((e, f) => {
            return e.AnswersSort - f.AnswersSort
          })
        }
      })
      item.AnswersCollect = item.AnswersCollect.sort((c, d) => {
        return c.AnswersSort - d.AnswersSort
      })
    }
  })
  // console.log(jmRes, '3333')
  qus.value = jmRes.AnswersQuestions.map((item) => {
    if (item.Question_QusType === 'S') {
      // 单选
      item.checked = ''
      // 单选二级
      item.AnswersCollect.forEach((item2) => {
        if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
          item2.firstChecked = ''
        }
      })
    }
    if (item.Question_QusType === 'M') {
      // 多选
      item.checked = []
      // 多选二级
      item.AnswersCollect.forEach((item2) => {
        if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
          item2.firstChecked = []
        }
      })
    }
    // 填空
    if (item.Question_QusType === 'F') {
      // 单选
      item.checked = item.AnswersCollect[0].AnswersID
    }
    if (item.AnswersCollect.length > 0) {
      item.AnswersCollect.map((itemo) => {
        itemo.otherCon = ''
      })
      item.AnswersCollect.forEach((item2) => {
        if (item2.ChildAnswers && item2.ChildAnswers.length > 0) {
          // 二级其他
          item2.ChildAnswers.forEach((items) => {
            items.otherCon = ''
          })
        }
      })
    }
    return item
  })
  // console.log(qus.value)
}
onMounted(() => {
  if (VisitorID.value) {
    if (gconfig.value.SuccessPageVersion === 'V2') {
      router.push({ path: '/successV2' })
    } else {
      router.push({ path: '/success' })
    }
  }
  getAns()
  if (isWeX.value) {
    // 获取微信签名 微信配置 分享等
    wx.getWXSign()
  }
})
const goback = () => {
  router.go(-1)
}
const ansArr = ref([])
const nextHandler = () => {
  ansArr.value = []
  for (let i = 0; i < qus.value.length; i++) {
    const item = qus.value[i]
    if (item.Questions_IsRequired) {
      // 如果必填
      if (item.Question_QusType === 'S') {
        // 单选
        if (item.checked === '') {
          showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
          return
        } else {
          const chooseAns = item.AnswersCollect.find((itemo) => {
            return itemo.AnswersID === item.checked
          })
          if (chooseAns.ChildAnswers && chooseAns.ChildAnswers.length > 0) {
            // 如果有二级
            if (chooseAns.firstChecked === '') {
              showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
              return
            } else {
              const schooseAns = chooseAns.ChildAnswers.find((items) => {
                return items.AnswersID === chooseAns.firstChecked
              })
              if (schooseAns.AnswersIsInput) {
                if (schooseAns.otherCon === '') {
                  showFailToast(`请填写问题 "${item.QuestionsQusTitle}"`)
                  return
                }
              }
              ansArr.value.push(
                `${item.QuestionsID}:${schooseAns.AnswersID}:${schooseAns.otherCon}`
              )
            }
          } else {
            if (chooseAns.AnswersIsInput) {
              if (chooseAns.otherCon === '') {
                showFailToast(`请填写问题 "${item.QuestionsQusTitle}"`)
                return
              }
            }
            ansArr.value.push(
              `${item.QuestionsID}:${chooseAns.AnswersID}:${chooseAns.otherCon}`
            )
          }
        }
      }
      if (item.Question_QusType === 'M') {
        // 多选
        if (item.checked.length <= 0) {
          showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
          return
        } else {
          const chooseAnsArr = []
          item.AnswersCollect.forEach((itemo) => {
            if (item.checked.indexOf(itemo.AnswersID) !== -1) {
              chooseAnsArr.push(itemo)
            }
            // 循环二级
            if (itemo.ChildAnswers) {
              itemo.ChildAnswers.forEach((items) => {
                if (item.checked.indexOf(items.AnswersID) > -1) {
                  // console.log(items, '1222')
                  chooseAnsArr.push(items)
                }
              })
            }
          })
          // console.log(chooseAnsArr, '222222222')
          for (let j = 0; j < chooseAnsArr.length; j++) {
            if (chooseAnsArr[j].AnswersIsInput) {
              if (!chooseAnsArr[j].otherCon) {
                showFailToast(`请填写问题 "${item.QuestionsQusTitle}"`)
                return
              }
            }
            ansArr.value.push(
              `${item.QuestionsID}:${chooseAnsArr[j].AnswersID}:${chooseAnsArr[j].otherCon}`
            )
          }
        }
      }
      if (item.Question_QusType === 'F') {
        if (!item.AnswersCollect[0].otherCon) {
          showFailToast(`请回答 "${item.QuestionsQusTitle}"`)
          return
        }
        ansArr.value.push(
          `${item.QuestionsID}:${item.checked}:${item.AnswersCollect[0].otherCon}`
        )
      }
    } else {
      // 如果非必填
      // console.log(2222)
    }
  }
  // console.log(ansArr, '333')
  subAns()
}
const subAns = async () => {
  const res = await api.saveAwsApi({
    VisitorID: VisitorID.value,
    token: token.value,
    ifSubmit: true,
    ExhCode: ExhCode.value,
    QueAndAnswers: ansArr.value.join(';')
  })
  if (res.code === 200) {
    store.commit('setVisitorID', res.data.visitorID)
    sessionStorage.setItem('invitesource', '1')
    sessionStorage.setItem('invitesourceID', res.data.visitorID)
    if (gconfig.value.SuccessPageVersion === 'V2') {
      router.push({ path: '/successV2' })
    } else {
      router.push({ path: '/success' })
    }
  }
}
const changeQueAns = (obj, ansObj) => {
  if (obj.Question_QusType === 'S') {
    // 单选
    obj.AnswersCollect.forEach((item) => {
      if (item.AnswersIsInput) {
        item.otherCon = ''
      }
    })
  }
  if (
    obj.Question_QusType === 'M' &&
    obj.checked.indexOf(ansObj.AnswersID) === -1
  ) {
    // 多选
    ansObj.otherCon = ''
  }
}
</script>
<style lang="less">
.secBox {
  padding: 6px 0 6px 27px;
}
.quetions {
  background: #fff;
  width: 96%;
  margin: 0 auto;
  border-radius: 6px;
  .van-radio-group > div,
  .opItem > div {
    padding: 8px 0;
  }
  .van-checkbox__label {
    text-align: left;
  }
}
.quebtns {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  .van-button {
    width: 45%;
  }
}
.queTit {
  text-align: left;
  padding: 15px 0;
  font-size: 15px;
  background: #f9f9f9;
}
.queSelItem {
  padding: 10px 15px;
}
.quetions {
  // padding: 0 20px;
}
// .otherConFiled {
//   border: 1px solid #333;
//   border-radius: 4px;
//   padding: 0 8px;
// }
</style>
